import { useState } from "react"
import { useTranslation } from "react-i18next"
import Select from 'react-select'

export const WardNameCommanDDL = () => {

    const { t } = useTranslation()

    const [WardNameID, setWardNameID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const optionsWardName = [
        { id: 1, value: 'प्रभाग-1', label: 'प्रभाग-1' },
        { id: 2, value: 'प्रभाग-2', label: 'प्रभाग-2' },
        { id: 3, value: 'प्रभाग-3', label: 'प्रभाग-3' },
    ]
    return (
        <>
            <label for="fname" className=" pb-2">{t('EncroachmentDashboard.WardName')}</label>
            <Select
                id='WardNameID'
                isClearable={false}
                // isRtl={isRtl}
                isSearchable
                maxMenuHeight={130}
                value={{ value: WardNameID.ID, label: WardNameID.Label }}
                onChange={(e) => {
                    e ?
                        setWardNameID({ ...WardNameID, ID: e.value, Label: e.label })
                        :
                        setWardNameID({ ...WardNameID, ID: 0, Label: "Select..." })

                }}
                options={optionsWardName}
            />
        </>
    )
}